import axios from 'axios';
import { TOKEN_STORAGE_KEY } from '../utils/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the token in requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add retry logic with exponential backoff
api.interceptors.response.use(
  response => response,
  async error => {
    // Handle 401 errors by clearing the token
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
    
    // Don't retry on 4xx client errors
    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      return Promise.reject(error);
    }
    
    // For network errors and 5xx server errors
    if (!error.response || error.response.status >= 500) {
      // Add a custom property to prevent infinite retries
      if (error.config && error.config._retry) {
        return Promise.reject(error);
      }
      
      // Mark this request as retried
      error.config._retry = true;
      
      // Show a clear message to user about connection issues
      error.message = "Failed to connect to server. Please check your connection and try again.";
    }
    
    return Promise.reject(error);
  }
);

export default api; 